<template>
  <div class="min-vh-100">
    <base-nav
      v-model="showMenu"
      type="light"
      :transparent="true"
      menu-classes="justify-content-end"
      class="navbar-horizontal navbar-main"
      expand="lg"
    >
      <div slot="brand" class="navbar-wrapper">
        <router-link class="navbar-brand" to="/">
          <img class="main-logo" :src="BrandWhite" />
        </router-link>
      </div>

      <template>
        <div class="navbar-collapse-header">
          <div class="row">
            <div class="col-6 collapse-brand">
              <router-link to="/">
                <img :src="Brand" />
              </router-link>
            </div>
            <div class="col-6 collapse-close">
              <button
                type="button"
                class="navbar-toggler"
                @click="showMenu = false"
              >
                <span></span>
                <span></span>
              </button>
            </div>
          </div>
        </div>

        <ul class="navbar-nav mr-auto">
          <li class="nav-item">
            <a href="/" class="nav-link">
              <span class="nav-link-inner--text">Main Website</span>
            </a>
          </li>
          <li v-if="!isAuthenticated" class="nav-item">
            <router-link :to="{ name: 'Log In' }" class="nav-link">
              <span class="nav-link-inner--text">Log In</span>
            </router-link>
          </li>
          <li v-if="!isAuthenticated" class="nav-item">
            <router-link :to="{ name: 'Sign Up' }" class="nav-link">
              <span class="nav-link-inner--text">Sign Up</span>
            </router-link>
          </li>
          <li v-if="isAuthenticated && !isEnrolled && !isTeam" class="nav-item">
            <router-link :to="{ name: 'Register' }" class="nav-link">
              <span class="nav-link-inner--text">Gain Access</span>
            </router-link>
          </li>
          <li v-if="isAuthenticated && (isEnrolled || isTeam)" class="nav-item">
            <router-link :to="{ name: 'Affiliate' }" class="nav-link">
              <span class="nav-link-inner--text">Affiliate Dashboard</span>
            </router-link>
          </li>
        </ul>
      </template>
    </base-nav>

    <div class="main-content">
      <zoom-center-transition :duration="pageTransitionDuration" mode="out-in">
        <router-view></router-view>
      </zoom-center-transition>
    </div>

    <footer class="footer bg-secondary px-4 mx-2">
      <div class="row align-items-center justify-content-lg-between">
        <div class="col-lg-6">
          <div class="copyright text-center text-lg-left text-muted">
            © {{ year }} ChinesePod LLC
          </div>
        </div>
        <div class="col-lg-6">
          <ul
            class="nav nav-footer justify-content-center justify-content-lg-end"
          >
            <li class="nav-item">
              <a href="/pricing" class="nav-link">Individual Pricing</a>
            </li>
            <li class="nav-item">
              <a href="/corporate" class="nav-link">For Companies</a>
            </li>
            <li class="nav-item">
              <a href="/start-learning-mandarin" class="nav-link">About Us</a>
            </li>
            <li class="nav-item">
              <a href="/blog" class="nav-link">Blog</a>
            </li>
          </ul>
        </div>
      </div>
    </footer>
  </div>
</template>
<script>
import { BaseNav } from '@/components'
import { ZoomCenterTransition } from 'vue2-transitions'
import BrandWhite from '@/assets/img/brand/brand-white.svg'
import Brand from '@/assets/img/brand/brand.svg'

import { mapGetters, mapActions } from 'vuex'

export default {
  components: {
    BaseNav,
    ZoomCenterTransition
  },
  props: {
    backgroundColor: {
      type: String,
      default: 'black'
    }
  },
  data() {
    return {
      showMenu: false,
      menuTransitionDuration: 250,
      pageTransitionDuration: 200,
      year: new Date().getFullYear(),
      pageClass: 'login-page',
      Brand: Brand,
      BrandWhite: BrandWhite
    }
  },
  computed: {
    ...mapGetters(['isAuthenticated', 'refreshToken']),
    ...mapGetters('affiliates', ['isEnrolled', 'isTeam'])
  },
  methods: {
    ...mapActions(['getToken', 'getUserInfo']),
    ...mapActions('affiliates', ['getAffiliateInfo']),
    toggleNavbar() {
      document.body.classList.toggle('nav-open')
      this.showMenu = !this.showMenu
    },
    closeMenu() {
      document.body.classList.remove('nav-open')
      this.showMenu = false
    },
    setBackgroundColor() {
      // document.body.classList.add('bg-default');
    },
    removeBackgroundColor() {
      // document.body.classList.remove('bg-default');
    },
    updateBackground() {
      if (!this.$route.meta.noBodyBackground) {
        this.setBackgroundColor()
      } else {
        this.removeBackgroundColor()
      }
    }
  },
  beforeDestroy() {
    this.removeBackgroundColor()
  },
  beforeRouteUpdate(to, from, next) {
    // Close the mobile menu first then transition to next page
    if (this.showMenu) {
      this.closeMenu()

      setTimeout(() => {
        next()
      }, this.menuTransitionDuration)
    } else {
      next()
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler: function () {
        this.updateBackground()
      }
    }
  },
  async mounted() {
    if (!this.isAuthenticated && this.refreshToken) {
      await this.getToken().catch(() => {})
    }
    if (this.isAuthenticated) {
      await Promise.all([
        this.getUserInfo().catch(() => {}),
        this.getAffiliateInfo().catch(() => {})
      ])
    }
  }
}
</script>
<style lang="scss">
$scaleSize: 0.8;
@keyframes zoomIn8 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
  100% {
    opacity: 1;
  }
}

.main-content .zoomIn {
  animation-name: zoomIn8;
}

@keyframes zoomOut8 {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}

.main-content .zoomOut {
  animation-name: zoomOut8;
}
.main-logo {
  height: 35px !important;
  @media (min-width: 400px) {
    height: 50px !important;
  }
  @media (min-width: 768px) {
    height: 60px !important;
  }
}
</style>
